export default function MangakuInfo() {
  return (
    <section id="info" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="rounded-2xl overflow-hidden h-96">
            <iframe
              title="カードショップ まんがく 高松市瓦町"
              src="https://www.google.com/maps?q=香川県高松市瓦町2-1-28&output=embed"
              className="w-full h-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div>
            <span className="text-xs tracking-[0.3em] text-red-500 font-medium uppercase mb-3 block">Shop Info</span>
            <h2 className="text-4xl font-serif text-gray-900 mb-4">店舗情報</h2>
            <div className="w-16 h-0.5 bg-red-300/50 mb-8"></div>
            <div className="flex flex-col gap-5">
              {[
                { icon: 'ri-map-pin-line', label: '住所', value: '香川県高松市瓦町2-1-28 高尾ビル2F南' },
                { icon: 'ri-time-line', label: '営業時間', value: '10:00〜19:00（平日・土日祝）' },
                { icon: 'ri-store-line', label: '業態', value: 'トレーディングカード 買取・販売' },
                { icon: 'ri-line-fill', label: 'LINE', value: '天神屋 公式LINEよりお問い合わせください' },
              ].map((item) => (
                <div key={item.label} className="flex items-start gap-4">
                  <div className="w-9 h-9 flex items-center justify-center bg-red-50 rounded-full flex-shrink-0">
                    <i className={`${item.icon} text-red-500 text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-0.5">{item.label}</p>
                    <p className="text-sm text-gray-700 font-medium">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="https://lin.ee/OGQq9z6"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#06C755] text-white px-6 py-3 rounded-full text-sm font-medium whitespace-nowrap hover:bg-[#05b34c] transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-line-fill text-sm"></i></div>
                LINEで買取相談
              </a>
              <a
                href="https://www.google.com/maps?q=香川県高松市瓦町2-1-28"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 border border-gray-200 text-gray-700 px-6 py-3 rounded-full text-sm font-medium whitespace-nowrap hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-line text-xs"></i></div>
                Googleマップで見る
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
